const normalizeText = text =>
  (text || '')
    .normalize('NFD')
    .replace(/\p{Mn}/gu, '')
    .toLowerCase()
    .trim();

// Keeps the items whose name contains the query, ignoring case and accents.
export const filterByName = (items, query) => {
  const normalizedQuery = normalizeText(query);
  if (!normalizedQuery) return items;

  return items.filter(item =>
    normalizeText(item.name).includes(normalizedQuery)
  );
};
